@if(showHeader) {
  <div
    class="modal-header rounded p-3 d-flex align-items-center position-relative overflow-visible pch-header"
    [ngClass]="{ 'rounded': rounded, 'dashboard-style': useDashboardStyle }"
    [ngStyle]="useDashboardStyle
      ? { 'background-color': '#ffffff', 'color': '#1a1a1a' }
      : { 'background-color': titlesUseSureSimBlue ? '#5563a0' : '#e9ecf1', 'color': titlesUseSureSimBlue ? 'white' : 'black' }"
  >
    @if (showBackButton) {
      <button
        #tooltipBack="ngbTooltip"
        aria-label="Back"
        class="btn btn-sm me-3 pch-back-button"
        [ngbTooltip]="showTooltips ? (backButtonTooltip ?? 'Back') : null"
        [ngStyle]="{ 'color': useDashboardStyle ? '#1a1a1a' : (titlesUseSureSimBlue ? 'white' : 'black') }"
        placement="bottom"
        tooltipClass="custom-tooltip-success"
        triggers="hover"
        type="button"
        (click)="backButtonOnClick(); tooltipBack.close()"
      >
        <i class="ri-arrow-left-line fs-18 align-middle"></i>
      </button>
    }

    @if (!hideHeaderLogo && titlesUseSureSimBlue && (!curUser.branded || curUser.isUtelize)) {
      <img
        alt="SureSIM Logo"
        class="me-3 pch-branding"
        [class.logo-grow-in]="sureSimLogoGrow"
        [height]="isPlatformModeInview ? 45 : 45"
        [src]="isPlatformModeInview ? 'assets/images/myinview-logo.png' : 'assets/images/SureSIM-Logo-Light-109.png'"
        [style.cursor]="showDateSelectorViaIconClick ? 'pointer' : 'default'"
        (click)="showDateSelectorViaIconClick && showDateSelectorOnClick()"
      />
    }

    <div class="d-flex flex-column pch-branding">
      <h4
        class="modal-title"
        [class.text-grow-in]="sureSimLogoGrow && !disableTitleAnimation"
        [class.dashboard-title]="useDashboardStyle"
        id="titleId"
        [style.color]="useDashboardStyle ? '#1a1a1a' : (titlesUseSureSimBlue ? 'white' : 'black')"
      >
        @if (title) { {{title}} } @else { Title has not been set }
      </h4>

      @if (label0Show && label0Text != undefined) {
        <small
          class="fw-semibold"
          [class.dashboard-subtitle]="useDashboardStyle"
          style="margin-top: 4px;"
          [style.color]="useDashboardStyle ? '#6c757d' : (titlesUseSureSimBlue ? 'rgba(255,255,255,0.85)' : '#5563a0')"
        >
          {{label0Text}}
        </small>
      }
    </div>

    @if (showSpinner) {
      <lord-icon
        src="https://cdn.lordicon.com/kbtmbyzy.json"
        trigger="loop"
        style="width: 75px; height: 75px; margin-left: 12px;"
        colors="primary:#ffffff,secondary:#ffffff"
      ></lord-icon>
    }

    <div class="d-flex ms-auto align-items-end gap-3 pch-actions">
      @if (showCompanyDropdown) {
        <app-dropdown-company
          style="width: 500px;"
          [hasFeature]="hasFeature"
          [hideLabel]="hideCompanyDropdownLabel"
          [hierarchyFormatting]="hierarchyFormatting"
          [includeCeased]="includeCeasedCompanies"
          [initialCompanyId]="initialCompanyId"
          [showSelectAllOption]="showCompanyDropdownSelectAllOption"
          (selectOnChangeEvent)="companyDropDownOnChange($event)"
          (selectOnChangeEvent2)="companyDropDownOnChange2($event)"
        ></app-dropdown-company>
      }

      @if (showBulkOrderDropdown) {
        <app-dropdown-orders-bulk #dropdownBulkOrdersComponent
          style="width: 500px;"
          [initialCompanyId]="initialCompanyId"
          (selectOnChangeEvent)="bulkOrderDropDownOnChange($event)"
        ></app-dropdown-orders-bulk>
      }

      @if (showReportDropdown) {
        <app-dropdown-financial-reports #dropdownFinancialReportsComponent
          [initialReportId]="initialReportId"
          (selectOnChangeEvent)="reportDropDownOnChange($event)"
        ></app-dropdown-financial-reports>
      }

      @if (showTypeLicenceDropdown) {
        <app-dropdown-licence-type
          style="width: 500px;"
          [initialLicenceTypeId]="initialTypeLicenceId"
          (selectOnChangeEvent)="typeLicenceDownOnChange($event)"
        ></app-dropdown-licence-type>
      }
      
      @if (filterDate0Show) {
        <app-dropdown-date
          [dateFormat]="filterDate0Format"
          [initialDate]="filterDate0"
          [monthSelector]="filterDate0MonthSelector ?? true"
          [title]="filterDate0Title ?? 'Month'"
          (selectOnChangeEvent)="filterDate0OnChange($event)"
        ></app-dropdown-date>
      }
      
      @if (filterDate1Show) {
        <app-dropdown-date
          [dateFormat]="filterDate1Format"
          [initialDate]="filterDate1"
          [monthSelector]="filterDate1MonthSelector ?? true"
          [title]="filterDate1Title ?? 'Month'"
          (selectOnChangeEvent)="filterDate1OnChange($event)"
        ></app-dropdown-date>
      }
      
      @if (showRefreshButton) {
        <button
          #tooltipRefresh="ngbTooltip"
          aria-label="Refresh"
          class="btn pch-refresh-button"
          [disabled]="refreshButtonDisabled===true"
          [ngbTooltip]="showTooltips ? (refreshButtonTooltip ?? 'Refresh') : null"
          placement="bottom"
          tooltipClass="custom-tooltip-success"
          type="button"
          (click)="refreshButtonOnClick(); tooltipRefresh.close()"
        >
          <i class="ri-refresh-line"></i>
        </button>
      }

      @if (button0Show) {
        <button
          #button0Ref
          class="btn btn-success"
          container="body"
          [disabled]="button0Disabled===true"
          id="pageCompButton0"
          [ngbTooltip]="button0Tooltip"
          placement="bottom-end auto"
          tooltipClass="custom-tooltip-success"
          type="button"
          (click)="button0OnClick()"
        >
          {{button0Text ? button0Text : "undefined button text"}}
        </button>
      }

      @if (button1Show) {
        <button
          #button1Ref
          class="btn btn-success"
          container="body"
          [disabled]="button1Disabled===true"
          id="pageCompButton1"
          [ngbTooltip]="button1Tooltip"
          placement="bottom-end auto"
          tooltipClass="custom-tooltip-success"
          type="button"
          (click)="button1OnClick()"
        >
          {{button1Text ? button1Text : "undefined button text"}}
        </button>
      }
      
      @if (button2Show) {
        <button
          #button2Ref
          class="btn btn-success"
          container="body"
          [disabled]="button2Disabled===true"
          id="pageCompButton2"
          [ngbTooltip]="button2Tooltip"
          placement="bottom-end auto"
          tooltipClass="custom-tooltip-success"
          type="button"
          (click)="button2OnClick()"
        >
          {{button2Text ? button2Text : "undefined button text"}}
        </button>
      }

      <!--RBW_20260604 - Named content-projection slot so callers can inject extra buttons into the banner (e.g. a cog dropdown) without modifying this component's @Input() set-->
      <ng-content select="[headerActions]"></ng-content>

      @if (showCancelButton) {
          <button
            aria-label="Close"
            class="btn-close position-absolute top-0 end-0 m-1"
            data-bs-dismiss="modal"
            id="close-modal"
            type="button"
            [ngStyle]="{ filter: titlesUseSureSimBlue ? 'invert(1) grayscale(100%) brightness(200%)' : 'none' }"
            (click)="cancelButtonClick()"
          >
          </button>
      }

      @if (switch0Show) {
        <div>
          <label class="form-check-label" for="pageCompSwitch0">{{switch0Text ? switch0Text : "undefined switch text"}}</label>
          <div class="form-check form-switch form-switch-md">
            <input 
              #switch0Ref
              [attr.disabled]="switch0IsDisabled ? true : null"
              class="form-check-input" 
              type="checkbox" 
              role="switch" 
              id="pageCompSwitch0" 
              [checked]="switch0Value"
              (change)="switch0OnChange()">
          </div>
        </div>
      }

      @if (switch1Show) {
        <div>
          <label class="form-check-label" for="pageCompSwitch0">{{switch1Text ? switch1Text : "undefined switch text"}}</label>
          <div class="form-check form-switch form-switch-md">
            <input 
              #switch1Ref
              [attr.disabled]="switch1IsDisabled ? true : null"
              class="form-check-input" 
              type="checkbox" 
              role="switch" 
              id="pageCompSwitch1" 
              [checked]="switch1Value"
              (change)="switch1OnChange()">
          </div>
        </div>
      }

      @if (showKeyButton) {
        <button
          #tooltipKey="ngbTooltip"
          [attr.aria-label]="keyButtonActive ? 'Hide key' : 'Show key'"
          [attr.aria-pressed]="keyButtonActive"
          class="btn pch-refresh-button pch-key-button"
          [class.active]="keyButtonActive"
          [ngbTooltip]="showTooltips ? (keyButtonTooltip ?? (keyButtonActive ? 'Hide key' : 'Show key')) : null"
          placement="bottom"
          tooltipClass="custom-tooltip-success"
          type="button"
          (click)="keyButtonOnClick(); tooltipKey.close()"
        >
          <i class="ri-key-2-line"></i>
        </button>
      }
    </div>
  </div>
  @if (showBottomBorder) {
    <div class="row mb-4"></div>
  }
}
